var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandButton(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.592,
    height: 18.592,
    viewBox: "0 0 18.592 18.592",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281",
    transform: "translate(-721.463 -628.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243",
    transform: "translate(740.055 628.433) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    d: "M9.3.689A8.607,8.607,0,0,0,3.21,15.382,8.607,8.607,0,1,0,15.382,3.21,8.551,8.551,0,0,0,9.3.689M9.3,0A9.3,9.3,0,1,1,0,9.3,9.3,9.3,0,0,1,9.3,0Z",
    transform: "translate(0)",
    fill: "#009ee2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M.344,7.24A.344.344,0,0,1,.1,6.653L3.134,3.62.1.588A.348.348,0,0,1,.1.1.345.345,0,0,1,.587.1L4.107,3.62.587,7.14A.343.343,0,0,1,.344,7.24Z",
    transform: "translate(8.045 5.625)",
    fill: "#009ee2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273",
    transform: "translate(740.055 628.433) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_42-2",
    "data-name": "Ellipse 42",
    d: "M9.3.689A8.607,8.607,0,0,0,3.21,15.382,8.607,8.607,0,1,0,15.382,3.21,8.551,8.551,0,0,0,9.3.689M9.3,0A9.3,9.3,0,1,1,0,9.3,9.3,9.3,0,0,1,9.3,0Z",
    transform: "translate(0)",
    fill: "#009ee2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34-2",
    "data-name": "Path 34",
    d: "M.344,7.24A.344.344,0,0,1,.1,6.653L3.134,3.62.1.588A.348.348,0,0,1,.1.1.345.345,0,0,1,.587.1L4.107,3.62.587,7.14A.343.343,0,0,1,.344,7.24Z",
    transform: "translate(8.045 5.625)",
    fill: "#009ee2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandButton);
export default __webpack_public_path__ + "static/media/expand-button.42bff4967c05e24e4b1ae9a78565c937.svg";
export { ForwardRef as ReactComponent };